import React, { Fragment } from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import ordinal from 'ordinal';
import styled from 'styled-components/native';
import Colors from '../colors';
import Spacer from '../spacer';
import Text from '../text';
import BreakdownRow from '../breakdown-row';
import DividerLine from '../divider-line';
import Currency from '../utilities/currency';
import { TYPES, StyledContainer } from './shared';
const DeductionRow = styled.View`
  flex-direction: row;
  justify-content: space-between;
`;
export default function Section(props) {
  const type = TYPES.includes(props.type) ? props.type : Section.defaultProps.type;
  return /*#__PURE__*/React.createElement(StyledContainer, null, props.deductionDates.length > 1 && props.unpaidTotal > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text.BodySmall, {
    color: Colors.gray400,
    weight: "bold"
  }, "Payment breakdown"), /*#__PURE__*/React.createElement(Spacer, {
    size: "f8",
    height: true
  }), /*#__PURE__*/React.createElement(Text.BodySmall, {
    color: Colors.gray300
  }, "Amount per deduction may vary if you have existing loans."), /*#__PURE__*/React.createElement(Spacer, {
    size: "f24",
    height: true
  })), props.deductionDates.map((date, i) => /*#__PURE__*/React.createElement(Fragment, {
    key: i
  }, /*#__PURE__*/React.createElement(DeductionRow, null, /*#__PURE__*/React.createElement(Text.BodySmall, {
    color: Colors.gray400
  }, ordinal(i + 1), ' ', "deduction"), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text.BodySmall, {
    color: Colors.gray400,
    align: "right"
  }, _.upperCase(moment(date).format('DD MMM YYYY'))), /*#__PURE__*/React.createElement(Spacer, {
    size: "f4",
    height: true
  }), /*#__PURE__*/React.createElement(Text.BodySmall, {
    color: Colors.gray400,
    align: "right"
  }, Currency.pesoFormat(Array.isArray(props.amount) ? props.amount[i] : props.amount), type === 'discount' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text.BodySmall, {
    color: Colors.gray400
  }, ' '), /*#__PURE__*/React.createElement(Text.BodySmall, {
    color: Colors.gray400,
    textDecorationLine: "line-through"
  }, Currency.pesoFormat(Array.isArray(props.totalAmountDueBeforeDiscount) ? props.totalAmountDueBeforeDiscount[i] : props.totalAmountDueBeforeDiscount)))))), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }))), /*#__PURE__*/React.createElement(Spacer, {
    size: "f4",
    height: true
  }), /*#__PURE__*/React.createElement(DividerLine, null), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), /*#__PURE__*/React.createElement(BreakdownRow, {
    type: "default",
    label: "Principal",
    amount: props.principal
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f4",
    height: true
  }), /*#__PURE__*/React.createElement(BreakdownRow, {
    type: "fees",
    label: "Fees",
    amount: props.fees,
    tooltip: props.feesTooltip
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f4",
    height: true
  }), /*#__PURE__*/React.createElement(BreakdownRow, {
    type: "default",
    label: "Interest",
    amount: props.interest
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f4",
    height: true
  }), type === 'discount' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BreakdownRow, {
    type: "discount",
    label: "Discount",
    amount: props.discount
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f4",
    height: true
  })), /*#__PURE__*/React.createElement(BreakdownRow, {
    type: type === 'default' ? 'default' : 'total',
    label: "Total Advance Due",
    amount: props.total
  }));
}
Section.defaultProps = {
  type: 'default',
  principal: 0,
  amount: 0,
  totalAmountDueBeforeDiscount: 0,
  fees: 0,
  interest: 0,
  discount: 0,
  total: 0,
  unpaidTotal: 0,
  deductionDates: [new Date()],
  feesTooltip: {
    title: '',
    content: '',
    contentMaxWidth: 200,
    textWidth: 136
  }
};
Section.propTypes = {
  type: PropTypes.oneOf(TYPES),
  principal: PropTypes.number,
  amount: PropTypes.number,
  totalAmountDueBeforeDiscount: PropTypes.number,
  fees: PropTypes.number,
  interest: PropTypes.number,
  discount: PropTypes.number,
  total: PropTypes.number,
  unpaidTotal: PropTypes.number,
  deductionDates: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  feesTooltip: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string,
    contentMaxWidth: PropTypes.number,
    textWidth: PropTypes.number
  })
};
//# sourceMappingURL=section.js.map